<template>

    <div class="modal-signature detenteur" :class="{ 'is-fullscreen': fullscreen }">
        <div class="modal">
            <h1>
                <strong>Enregistrer</strong>
                <br> une signature</h1>
            <canvas class="signature" ref="canvasPad" id="signaturepad" :width="canvasWidth" :height="canvasHeight" style="touch-action: none;"></canvas>
            <p class="warning"></p>
            <div style="display:flex; justify-content: center;">
                <a href="javascript: void 0" @click.prevent="clearPad" class="btn clean">Effacer</a>
                <a href="javascript: void 0" @click.prevent="savePad" class="btn save">Enregistrer</a>
            </div>
            <i class="fas" :class="fullscreen ? 'fa-compress' : 'fa-expand'" id="fullscreen-sign" @click="toggleFullscreen"></i>
            <i class="icon icon-error" id="close-sign" @click="closePad"></i>
        </div>
    </div>

</template>

<script>

import SignaturePad from 'signature_pad'

export default {
    data() {
        return {
            pad: null,
            fullscreen: false,
            canvasWidth: 300,
            canvasHeight: 200,
            padData: null, // points vectoriels { points, width, height }
        }
    },
    props: {
        signature: null,
        clearOnClose: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.initPad(this.signature)
    },
    methods: {
        initPad(existingImageData) {
            this.$nextTick(() => {
                this.$nextTick(() => {
                    const canvas = this.$refs.canvasPad
                    if (!canvas) return

                    if (this.pad) this.pad.off()
                    const scale = this.canvasWidth / 300
                    this.pad = new SignaturePad(canvas, {
                        minWidth: 0.5 * scale,
                        maxWidth: 2.5 * scale,
                    })

                    if (this.padData) {
                        // Données vectorielles dispo : rescale les coordonnées → net à toute taille
                        const scaleX = this.canvasWidth / this.padData.width
                        const scaleY = this.canvasHeight / this.padData.height
                        const scaledPoints = this.padData.points.map(stroke =>
                            stroke.map(point => Object.assign({}, point, {
                                x: point.x * scaleX,
                                y: point.y * scaleY,
                            }))
                        )
                        this.pad.fromData(scaledPoints)
                    } else if (existingImageData) {
                        // Signature existante en base64 (prop) : drawImage uniquement au premier chargement
                        setTimeout(() => {
                            this.pad.clear()
                            let image = new Image()
                            image.src = existingImageData
                            image.onload = () => {
                                canvas.getContext('2d').drawImage(image, 0, 0, this.canvasWidth, this.canvasHeight)
                            }
                            this.pad._isEmpty = false
                        }, 200)
                    }
                })
            })
        },
        toggleFullscreen() {
            // Sauvegarder les points vectoriels avant redimensionnement
            if (this.pad && !this.pad.isEmpty()) {
                const points = this.pad.toData()
                if (points && points.length > 0) {
                    this.padData = { points, width: this.canvasWidth, height: this.canvasHeight }
                }
            }

            if (this.fullscreen) {
                this.fullscreen = false
                this.canvasWidth = 300
                this.canvasHeight = 200
            } else {
                this.fullscreen = true
                this.canvasWidth = Math.floor(window.innerWidth) - 40
                this.canvasHeight = Math.floor(window.innerHeight) - 180
            }

            this.initPad(null)
        },
        clearPad() {
            this.pad.clear()
            this.padData = null
        },
        savePad() {
            if (this.pad.isEmpty()) {
                this.$el.querySelector('p.warning').textContent = 'Signature vide non autorisée'
            } else {
                this.$el.querySelector('p.warning').textContent = '';
                this.$emit('signatureUpdated', this.pad.toDataURL());
                this.closePad()
            }
        },
        closePad() {
            if(this.clearOnClose){
                this.clearPad()
            }
            this.$emit('close')
        }
    }
}

</script>

<style>

#close-sign{
    position: absolute;
    top: 25px;
    right: 25px;
    font-size: 2.5rem;
    color: #c31616;
}

.modal-signature {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background-color: rgba(55, 55, 54, 0.9);
    z-index: 99;
}

.modal-signature > div {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    margin: auto;
    margin-top: -200px;
    background-color: white;
    width: calc(100% - 20px);
    max-width: 350px;
    height: 400px;
    display: block;
    padding-top: 35px;
    padding-bottom: 20px;
    text-align: center;
    border-radius: 5px;
}

/* Fullscreen mode */
.modal-signature.is-fullscreen > div {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    margin-top: 0;
    width: 100%;
    max-width: none;
    height: 100%;
    border-radius: 0;
    padding-top: 20px;
    padding-bottom: 15px;
    box-sizing: border-box;
}

.modal-signature>div h1 {
    margin-bottom: 25px;
}

.modal-signature.is-fullscreen > div h1 {
    margin-bottom: 10px;
    font-size: 1.8rem;
}

.modal-signature>div canvas {
    padding: 0;
    margin: auto;
    display: block;
    border-radius: 4px;
    border: 1px solid #999;
}

.modal-signature.is-fullscreen > div canvas {
    border-radius: 0;
    border: 2px solid #5698d2;
}

.modal-signature>div p.warning {
    margin-top: 10px;
    color: #c31616;
    text-transform: uppercase;
}

.modal-signature.is-fullscreen > div p.warning {
    margin-top: 5px;
}

.modal-signature>div>div {
    padding-top: 25px;
    gap: 8px;
}

.modal-signature.is-fullscreen > div > div {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
    gap: 8px;
}

.modal-signature>div>div .clean {
    width: 120px;
    background-color: #999;
    color: white;
    font-size: 1.6rem;
    font-weight: 700;
    text-transform: uppercase;
    align-items: center;
    line-height: 3;
}

.modal-signature>div>div .save {
    background-color: #5698d2;
    width: 160px;
    color: white;
    font-size: 1.6rem;
    font-weight: 700;
    text-transform: uppercase;
    align-items: center;
    line-height: 3;
}

.modal-signature.is-fullscreen > div > div .clean,
.modal-signature.is-fullscreen > div > div .save {
    flex: 1;
    width: auto;
    font-size: 1.8rem;
    line-height: 3.5;
}

#fullscreen-sign {
    position: absolute;
    top: 25px;
    left: 25px;
    font-size: 2.5rem;
    color: #5698d2;
    cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// SignatureModal.vue?718d75cc